import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyC3d9V_KolVpxA_6wMsb7vL_75mN2OQQ34',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'moj-express.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'moj-express',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'moj-express.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '436311630921',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:436311630921:web:4d62c985e2cb0effefcb98',
};

const hasFirebaseConfig = Object.values(firebaseConfig).every(Boolean);

let db = null;

if (hasFirebaseConfig) {
  const app = initializeApp(firebaseConfig);
  db = getFirestore(app);
}

export { db, hasFirebaseConfig };
